/** 设备 id 不能是邮箱/username 字符串 */
export const isUpgradeDeviceId = value => {
  const id = value != null ? String(value).trim() : ''
  return id !== '' && !id.includes('@')
}

/** 在 allDeviceUser 里用 iCloud 账号反查数字 device_id（兼容旧 localStorage） */
const lookupDeviceIdByUsername = username => {
  const name = username != null ? String(username).trim() : ''
  if (!name) return null

  try {
    const allDeviceUser = JSON.parse(localStorage.getItem('allDeviceUser') || '[]')
    if (!Array.isArray(allDeviceUser)) return null

    const matched = allDeviceUser.find(
      device => String(device?.iCloud_username ?? '').toLowerCase() === name.toLowerCase()
    )
    const id = matched?.id ?? matched?.device_id
    return isUpgradeDeviceId(id) ? id : null
  } catch {
    return null
  }
}

/**
 * 解析升级/checkout-9 用的 device_id。
 * 优先 Redux 侧栏选中态；缺失时读 localStorage；仍无则按 username 在 allDeviceUser 反查。
 * 绝不返回邮箱。
 */
export const resolveUpgradeDeviceId = reduxDeviceUser => {
  if (isUpgradeDeviceId(reduxDeviceUser)) {
    return String(reduxDeviceUser).trim()
  }

  try {
    const deviceUser = JSON.parse(localStorage.getItem('DeviceUser') || 'null')
    const directId = deviceUser?.device_id ?? deviceUser?.id
    if (isUpgradeDeviceId(directId)) {
      return String(directId).trim()
    }

    return lookupDeviceIdByUsername(deviceUser?.username)
  } catch {
    return null
  }
}

/** Redux 初始 deviceUser：只存 device_id，不回落到 username/邮箱 */
export const readInitialDeviceUserId = () => {
  if (typeof window === 'undefined') return ''

  try {
    const saved = JSON.parse(localStorage.getItem('DeviceUser') || 'null')
    if (!saved) return ''

    const directId = isUpgradeDeviceId(saved.device_id) ? saved.device_id : saved.id
    if (isUpgradeDeviceId(directId)) {
      return String(directId).trim()
    }

    // DeviceUser 被旧路径写成只剩 username（没有 id）时，先看 currentDevice 里内嵌的设备 id：
    // 它一定是真实 id，比用邮箱反查可靠 —— 同一个邮箱绑多个账号时反查只会挑到第一个。
    const currentDevice = JSON.parse(localStorage.getItem('currentDevice') || 'null')
    const fromCurrentDevice = currentDevice?.DeviceUser?.device_id ?? currentDevice?.DeviceUser?.id
    if (isUpgradeDeviceId(fromCurrentDevice)) {
      return String(fromCurrentDevice).trim()
    }

    const fromList = lookupDeviceIdByUsername(saved.username)
    return fromList != null ? String(fromList).trim() : ''
  } catch {
    return ''
  }
}
